/**
 * Created by Ning Jiang on 3/20/2017.
 */

import {ServerDataParser} from "@nolimitcity/slot-game/bin/core/server/ServerDataParser";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/core/utils/ArrayHelper";
import {AvalancheServerDataParser} from "@nolimitcity/slot-game/bin/game/reel/avalanchereel/AvalancheServerDataParser";
import {
    IAvalancheGameData,
    IAvalancheServerData
} from "@nolimitcity/slot-game/bin/game/reel/avalanchereel/IAvalancheServerData";
import {isBoolean} from "util";
import {IDragonTribeGameData, IDragonTribeServerData} from "./data/IDragonTribeServerData";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {IBetWinData, IGameData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";

export class DragonTribeServerDataParser extends AvalancheServerDataParser {

    constructor() {
        super();
    }

    public parseMysterySymbolOnReel(rawData:IDragonTribeGameData):boolean[] {
        return rawData.mysterySymbolOnReel.concat();
    }

    public parseMysterySymbolPositions(rawData:IDragonTribeGameData):number[] {
        return rawData.mysterySymbolPositions.concat();
    }

    public parseMysterySymbolRevealed(rawData:IDragonTribeGameData):string {
        return rawData.mysterySymbolRevealed;
    }

    public parseMysterySymbolSize(rawData:IDragonTribeGameData):number[] {
        return rawData.mysterySymbolSize.concat();
    }

    public parseXWaysSymbolMayGiveWin(rawData:IDragonTribeGameData):boolean {
        return rawData.xWaysSymbolMayGiveWin;
    }

    public parseReels(rawData:IDragonTribeServerData):string[][] {
        rawData.gameAreaSize.forEach((reelSize:number, reelId:number) => {
            (<number[]>GameConfig.instance.STACKED_SYMBOLS!["W0"].totalNum)[reelId] = reelSize;
        });

        return super.parseReels(rawData);
    }

    public parseBetWins(rawData:IGameData):IBetWinData[] {
        if(!GameConfig.instance.BET_WIN_MODE) {
            throw new Error("ServerDataParser.parseBetWins(): Invalid BetWinMode from GameConfig!");
        }
        return rawData.betWayWins!;
    }

    public parseSingleWin(rawData:IDragonTribeGameData):number {
        return parseFloat(rawData.thisAvalancheWinnings);
    }

    public parseAvalancheTotalWin(rawData:IDragonTribeGameData):number {
        return parseFloat(rawData.totalAvalancheRoundWinnings);
    }
}